exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_slides_1HoXa1QCSqY5ulf56ZjuHX {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_icWOUmbp6vevmJQ6V5D-C {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_ut4HTr4v7kn3aAVQda-Ue {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_18KUKYnbO18v80Zh9kLQWT {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_slides": "IA_slides_1HoXa1QCSqY5ulf56ZjuHX",
	"IA_filters": "IA_filters_icWOUmbp6vevmJQ6V5D-C",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_ut4HTr4v7kn3aAVQda-Ue",
	"IA_paginationPageCount": "IA_paginationPageCount_18KUKYnbO18v80Zh9kLQWT"
};